import { Module } from "types/generated";

export const canSetModuleFavorite = (module: Module): boolean => !module.starred;
export const canUnsetModuleFavorite = (module: Module): boolean => module.starred;
